import { useGetList } from 'react-admin';
import { hasRole } from '../utils/roles';

export interface OwnRestaurant {
  id: number | string;
  name?: string;
}

/**
 * Jedyna restauracja zalogowanego uzytkownika — dla rol RESTAURANT_OWNER i
 * VENDOR, ktore z definicji maja dokladnie jedna lokalizacje.
 *
 * Backend (`location/list`) i tak zwraca takiemu uzytkownikowi tylko jego
 * lokalizacje, wiec bierzemy pierwszy rekord zamiast filtrowac po czymkolwiek
 * po stronie klienta. Parametry zapytania celowo pokrywaja sie z tymi, ktorych
 * uzywa `<List>` w `LocationTable` (perPage 25, sort id ASC) — dzieki temu na
 * ekranie lokalizacji react-query trafia w ten sam wpis cache i nie robi
 * drugiego strzalu do API.
 *
 * Dla pozostalych rol zapytanie w ogole nie startuje (`enabled: false`).
 */
export const useOwnRestaurant = (): { restaurant: OwnRestaurant | null; isLoading: boolean } => {
  const isSingleRestaurantRole = hasRole('RESTAURANT_OWNER', 'VENDOR');

  const { data, isLoading } = useGetList<any>(
    'locationsManagement',
    { pagination: { page: 1, perPage: 25 }, sort: { field: 'id', order: 'ASC' }, filter: {} },
    { enabled: isSingleRestaurantRole },
  );

  return {
    restaurant: isSingleRestaurantRole ? ((data?.[0] as OwnRestaurant) ?? null) : null,
    isLoading: isSingleRestaurantRole && isLoading,
  };
};
